import { Post, postJSON } from "../utils/http"

export function getComm(params, config = {}) {
  return Post("/api/terns/init", params, config)
}
export function getStoreInfo(params, config = {}) {
  return postJSON("/api/terns/storeInfo", params, config)
}
